import React from "react";
import {Redirect} from "react-router-dom";

/**
 * Stránka pro přesměrování na výchozí stránku.
 */
class RedirectToDefaultPage extends React.Component {
  render() {
    return (
      <Redirect to="/" />
    );
  }
}

export default RedirectToDefaultPage;
